import { render } from "./ComplaintsBook.vue?vue&type=template&id=e4a2960e&scoped=true"
import script from "./ComplaintsBook.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintsBook.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintsBook.vue?vue&type=style&index=0&id=e4a2960e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a2960e"],['__file',"resources/frontend/js/components/ComplaintsBook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4a2960e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4a2960e', __exports__)) {
    api.reload('e4a2960e', __exports__)
  }
  
  module.hot.accept("./ComplaintsBook.vue?vue&type=template&id=e4a2960e&scoped=true", () => {
    api.rerender('e4a2960e', render)
  })

}


export default __exports__